(function() {
	handleDialog();

	function handleDialog() {
		let queryParams = new URLSearchParams(location.search);
		if(!queryParams.has("dialog")) {
			return;
		}

		let dialog = document.getElementById(queryParams.get("dialog"));
		if(!dialog) {
			return;
		}

		dialog.showModal();
		queryParams.delete("dialog");
		history.pushState({}, "", location.pathname + "?" + queryParams.toString());
	}
})();
